/**
 * Shared types used across multiple components.
 * Import from here instead of re-declaring locally in each file.
 */

/** The three resolutions served for every shirt photo. */
export interface ImageUrl {
  thumbnail: string;
  original: string;
  optimized: string;
  order?: number;
}

/** A photo file selected for upload, with an object-URL preview. */
export interface Photo {
  id: string;
  file: File;
  url: string;
}

/** Common fields shared between a fixed-price and auction sell form. */
export interface SellFormBase {
  photos: Photo[];
  league: string;
  size: string;
  team: string;
  playerName: string;
  season: string;
  condition: string;
  matchworn: boolean;
  matchInfo: string;
  goals: number;
  assists: number;
  description: string;
  createdAt: string;
}

/** Payload emitted by the FixedPriceForm on submit. */
export interface FixedPriceSellPayload extends SellFormBase {
  type: "fixed";
  price: number;
}

/** Payload emitted by the AuctionForm on submit. */
export interface AuctionSellPayload extends SellFormBase {
  type: "auction";
  minimumBid: number;
  auctionDuration: number;
  auctionUnit: "hours" | "days";
}

/** Either form payload. */
export type SellPayload = FixedPriceSellPayload | AuctionSellPayload;

/**
 * Extract a human-readable message from an unknown catch-clause value.
 * Replaces the `err: any` pattern with safe narrowing.
 */
export function getErrorMessage(
  err: unknown,
  fallback = "Er ging iets mis",
): string {
  if (err instanceof Error) return err.message || fallback;
  if (typeof err === "string") return err || fallback;
  return fallback;
}
